<template>
  <el-table-column
    prop="model"
    sortable
    label="Model"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.model }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'model',
  };
</script>
